import React from 'react';
import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconMailStroke(props: IconType) {
    const {
        width = '16',
        height = '16',
        stroke = '#070c63',
        viewBox = '0 0 16 16',
        title = 'IconMailStroke',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            stroke={stroke}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <g
                    fill="none"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(1 3)"
                >
                    <path
                        d="m12.25-.5c.4832735 0 .9207653.19587355 1.2374436.51255178.3166869.31668693.5125564.75418974.5125564 1.23744822v7.5c0 .48328-.1958683.92077508-.5125466 1.23745339s-.7541734.51254661-1.2374534.51254661h-10.5c-.48325849 0-.92076129-.1958695-1.23744822-.51255644-.31667823-.31667823-.51255178-.75417005-.51255178-1.23744356v-7.5c0-.483252.19587477-.92075155.51256161-1.23743839.31668684-.31668685.75418639-.51256161 1.23743839-.51256161z"
                    />
                    <path d="m2 2 5 3.88888889 5-3.88888889"/>
                </g>
            )}
        />

    );
}

export default IconMailStroke;
